import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { FdFieldConfigs } from '../../../shared/fd-form-components/fd-form-components.module';
import { InputType } from '../../../shared/fd-form-components/fd-input/fd-input.component';
import { cpfMask } from '../../../shared/masks/document-masks';
import { Messages } from '../../../shared/messages/messages';
import { LoginService } from '../../services/login.service';
import { LoginModel } from '../../../shared/models/login.model';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/service/auth.service';
import { LoadingService } from '../../../shared/service/loading.service';
import { finalize } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { DialogService } from '../../../shared/service/dialog.service';
import { ErrorService } from '../../../shared/service/error.service';
import { Routes } from 'src/app/shared/routing/routes';
import { AdminRolesEnum } from 'src/app/shared/enums/admin-roles.enum';
import { firstValueFrom, Observable } from 'rxjs';
import {AuthServiceModel} from "../../../shared/models/response/auth-service.model";
import { Item } from 'src/app/shared/fd-form-components/fd-select/fd-select.component';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    standalone: false
})
export class LoginComponent implements OnInit {

  formGroup: UntypedFormGroup;
  fields: FdFieldConfigs;

  loginActive = true;
  isMFA: boolean = false;
  correlationId:string;
  radioValue: string = '';
  isOptOptionDisabled: boolean = false;

  userEmail: string = '';
  userPhone: string = '';

  constructor(
    private formBuilder: UntypedFormBuilder,
    private loginService: LoginService,
    private errorService: ErrorService,
    private dialogService: DialogService,
    private router: Router,
    protected authService: AuthService,
    protected matDialog: MatDialog,
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.loadingService.hide();
    this.startForms();
  }

  ngAfterContentChecked(): void {
    this.cdr.detectChanges();
  }

  handlerMFAPaste(token) {
    this.formGroup.controls['mfaToken'].setValue('');
    this.formGroup.controls['mfaToken'].setValue(token);
    this.login();
  }


  startForms(): void {
    this.formGroup = this.formBuilder.group({
      user: ['', Validators.required],
      password: ['', Validators.required],
      mfaToken:[],
      tokenChannel: [],
    });

    this.fields = {
      user: {
        label: 'CPF',
        disabled: false,
        controlName: 'user',
        mask: cpfMask,
        maskCharsReplace: /[. / -]/g,
        messages: {
          required: 'Informe um usuário válido',
          invalid: 'Usuário inválido'
        }
      },
      password: {
        label: 'Senha',
        disabled: false,
        controlName: 'password',
        type: InputType.PASSWORD,
        messages: {
          required: 'Informe a senha',
          invalid: 'Senha inválida'
        }
      },
      mfaToken: {
        label: 'Informe o token recebido',
        disabled: false,
        controlName: 'mfaToken',
        type: InputType.TEXT,
        messages: {
          required: 'Informe o token recebido',
          invalid: 'Token invalido'
        }
      }
    };
  }

  goToPasswordRecovery() {
    this.router.navigate(['/password-recovery']);
  }

  defineNextPage() {

    const roles = this.authService.getUserRoles();

    switch (true) {
      case this.authService.isUserInRoles([AdminRolesEnum.MONITORING]):
        this.router.navigate([Routes.SEARCH_PROPOSALS]);
        return;

      case this.authService.isUserInRoles([AdminRolesEnum.PRICING_READ, AdminRolesEnum.PRICING_WRITE]):
        this.router.navigate([Routes.PRICE_CAMPAIGN])
        return;

      case this.authService.isUserInRoles([AdminRolesEnum.CONFIGURATION_READ, AdminRolesEnum.CONFIGURATION_WRITE]):
        this.router.navigate([Routes.SERVICE_CONFIG]);
        return;

      case this.authService.isUserInRoles([AdminRolesEnum.USERS_READ, AdminRolesEnum.USERS_ADMIN_WRITE, AdminRolesEnum.USERS_VENDOR_WRITE]):
        this.router.navigate([Routes.USERS]);
        return;

      case this.authService.isUserInRoles([AdminRolesEnum.CNAE_CREDIT_RISK_READ, AdminRolesEnum.CNAE_CREDIT_RISK_WRITE]):
        this.router.navigate([Routes.CNAE_CREDIT_RISK_REGISTER]);
        return;

      case this.authService.isUserInRoles([AdminRolesEnum.MCC_PHYSICAL_PERSON_READ, AdminRolesEnum.MCC_PHYSICAL_PERSON_WRITE]):
        this.router.navigate([Routes.MCC_PHYSICAL_PERSON_REGISTER]);
        return;
    }
  }

  reenviarToken() {
    const cpfCnpj = this.formGroup.value.user;
    const senha = this.formGroup.value.password;
    const sendBy = this.formGroup.getRawValue().tokenChannel;
    this.sendOtpToken(cpfCnpj, senha, sendBy);
  }

  enableOtpOption(){
    this.formControls.tokenChannel.enable();
    this.formControls.tokenChannel.setValue('');
    this.radioValue = '';
    this.isOptOptionDisabled = false;
  }

  disableOtpOption(value: string){
    this.radioValue = value;
    this.formControls.tokenChannel.disable();
    this.formControls.tokenChannel.setValue(value);
    this.formGroup.value.tokenChannel = value;
    this.isOptOptionDisabled = true;
  }

  async isRadioSelected(event) {
    const userCpfCnpj = this.formGroup.value.user;
    const userPassword = this.formGroup.value.password;
    const optionSelected = event.value;

    this.disableOtpOption(optionSelected);
    await this.sendOtpToken(userCpfCnpj, userPassword, optionSelected);
  }

  async login() {
    if(this.isMFA && !this.radioValue){
      this.dialogService.openDialog(Messages.LOGIN_ERROR_INVALID_SENDBY_OPTION);
      return;
    }

    this.loginActive = false;

    if(this.isMFA) {
      await this.executeLoginMFA();
    } else {
      await this.checkOtp();
    }
  }


  async checkOtp(){
    try {
      this.loadingService.show();
      const cpfCnpj = this.formGroup.value.user;
      const senha = this.formGroup.value.password;
      const data = new LoginModel({cpfCnpj: cpfCnpj, senha: senha});
      const response = await firstValueFrom(this.loginService.checkOtp(data).pipe(finalize(() => this.loadingService.hide())));

      if (response.isOtpEnabled) {
        this.isMFA = true;
        this.loginActive = true;
        this.userEmail = response.email;
        this.userPhone = response.telefoneCelular;
      } else {
        await this.executeLogin(data);
      }
    } catch (err) {
      this.handleError(err);
    }
  }

  async sendOtpToken(cpfCnpj: string, senha: string, sendBy: string){
    try {
      this.loadingService.show();
      const data = new LoginModel({cpfCnpj: cpfCnpj, senha: senha, sendBy: sendBy});

      const response = await firstValueFrom(this.loginService.sendOtpToken(data)
      .pipe(finalize(() => this.loadingService.hide())));
      const correlationId = response?.otpDetails?.correlationId || '';

      if(correlationId){
        this.correlationId = correlationId;
        if (sendBy === 'SMS') {
          this.dialogService.openDialog(Messages.LOGIN_SEND_TOKEN_SMS);
        } else {
          this.dialogService.openDialog(Messages.LOGIN_SEND_TOKEN_EMAIL);
        }
      } else {
        this.dialogService.openDialog(Messages.LOGIN_ERROR_INVALID_CORRELATIONID, () => this.router.navigate([Routes.LOGIN]));
      }
    } catch(err){
      this.handleError(err);
    }
  }

  async executeLogin(data) {
    try {
      this.loadingService.show();
      const loginResponse = await firstValueFrom(this.loginService.login(data).pipe(finalize(() => this.loadingService.hide())));

      this.authService.loginSuccess(loginResponse);
      this.defineNextPage();
      this.loginActive = true;
    } catch (err) {
      this.handleError(err);
    }
  }

  handleError(err: any) {
    this.loadingService.hide();
    if (err instanceof HttpErrorResponse) {
      this.loginActive = true;
      if (err.error.data === "USER_PASSWORD_EXPIRATED") {
        err.error.data = null;
        this.errorService.handleXHRError(err, Messages.LOGIN_ERROR, () =>
          this.router.navigate([Routes.PASSWORD_RECOVERY])
        );
      } else {
        this.errorService.handleXHRError(err, Messages.LOGIN_ERROR);
      }
    } else {
      this.errorService.handleXHRError(err, Messages.LOGIN_ERROR);
    }
  }

  async executeLoginMFA(){
    this.loadingService.show();
    const cpfCnpj = this.formGroup.value.user;
    const senha = this.formGroup.value.password;
    const correlationId = this.correlationId;
    const tokenOTP = this.formGroup.value.mfaToken;
    const sendBy = this.formGroup.getRawValue().tokenChannel;
    const data = new LoginModel({
      cpfCnpj: cpfCnpj, senha: senha,
      correlationId: correlationId, tokenOTP: tokenOTP, sendBy: sendBy
    });

    try {
      const response = await firstValueFrom(this.loginService.loginMFA(data)
        .pipe(finalize(() => this.loadingService.hide())));
      this.authService.loginSuccess(response);
      this.defineNextPage();
      this.loginActive = true;
    } catch (error) {
      const httpError = error as HttpErrorResponse;
      this.loginActive = true;
      if (httpError?.error?.data === 'USER_PASSWORD_EXPIRATED') {
        httpError.error.data = null;
        this.errorService.handleXHRError(httpError, Messages.LOGIN_ERROR, () => this.router.navigate([Routes.PASSWORD_RECOVERY]));
      } else {
        this.errorService.handleXHRError(httpError, Messages.LOGIN_ERROR);
      }
    }
  }

  public isLoginDisabled(): boolean {
    return !this.loginActive;
  }

  get formControls() {
    return this.formGroup.controls;
  }

}
